import { useTranslation } from 'react-i18next'
import { GlobalContentContainer, MainButton, BigText } from '../../../App.styled'
import { signLink, siteName} from '../../../helpers/consts'
import {
  Section,
  SectionContainer,
  LeftContent,
  SectionImage,
  SectionTitle,
} from './styled'

import sectionImage from '../../../images/main-page/topImage.png'

const TopSection = () => {
  const { t } = useTranslation()

  return (
    <Section>
      <GlobalContentContainer>
        <SectionContainer>
          <LeftContent>
            <SectionTitle>{siteName}</SectionTitle>
         
            <BigText hasMargin>{t('PAGE_MAIN.TOP')}</BigText>

            <MainButton href={signLink}>{t('GLOBAL.REGISTER')}</MainButton>
          </LeftContent>

          <SectionImage src={sectionImage} alt={`${siteName} - ${t('GLOBAL.CREATE_ACCOUNT')}`}/>
        </SectionContainer>
      </GlobalContentContainer>
    </Section>
  )
}

export default TopSection
